var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Transition',{attrs:{"css":false,"mode":"out-in"},on:{"before-enter":_vm.beforeEnter,"enter":_vm.enter,"leave":_vm.leave}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }